
import { Message } from "src/layouts/AskDatatram/ChatInterface";
import { getTime } from "src/utils/ScheduleUtils"; 

const isArabicText = (text: string) => /[؀-ۿ]/.test(text);

const fallbackEntries: { keywords: string[]; en: string; ar: string }[] = [
  {
    keywords: ["hi", "hey", "هاي", "هلا"],
    en: "👋 Hi there! How can I help you today?",
    ar: "👋 أهلاً بك! كيف يمكنني مساعدتك اليوم؟",
  },
  {
    keywords: ["hello", "مرحبا", "مرحباً", "السلام عليكم", "اهلا", "أهلا"],
    en: "👋 Hi there! How can I help you today?",
    ar: "👋 مرحباً بك! كيف يمكنني مساعدتك اليوم؟",
  },
  {
    keywords: ["good morning", "صباح الخير"],
    en: "🌅 Good morning! Ready to plan your next campaign?",
    ar: "🌅 صباح الخير! هل أنت مستعد للتخطيط لحملتك القادمة؟",
  },
  {
    keywords: ["good evening", "مساء الخير"],
    en: "🌇 Good evening! How may I assist you?",
    ar: "🌇 مساء الخير! كيف يمكنني مساعدتك؟",
  },
  {
    keywords: ["thanks", "thank you", "thankyou", "thx", "شكرا", "شكراً", "شكرا لك", "شكراً لك"],
    en: "😊 You’re most welcome! Always happy to help.",
    ar: "😊 على الرحب والسعة! سعيد دائماً بمساعدتك.",
  },
  {
    keywords: ["bye", "مع السلامة", "الى اللقاء", "إلى اللقاء"],
    en: "👋 Goodbye! Have a productive day ahead.",
    ar: "👋 مع السلامة! أتمنى لك يوماً مثمراً.",
  },
  {
    keywords: ["see you", "اراك لاحقا", "أراك لاحقاً"],
    en: "👋 See you soon!",
    ar: "👋 أراك قريباً!",
  },
  {
    keywords: ["who are you", "من انت", "من أنت"],
    en: "🤖 I’m your Datatram AI assistant. I help you with campaigns and insights.",
    ar: "🤖 أنا مساعد داتاترام الذكي، أساعدك في الحملات والتحليلات.",
  },
  {
    keywords: ["help", "مساعدة", "ساعدني"],
    en: "💡 You can ask me to create campaigns, analyze engagement, or check ROAS reports.",
    ar: "💡 يمكنك أن تطلب مني إنشاء حملات أو تحليل التفاعل أو التحقق من تقارير العائد على الإنفاق الإعلاني.",
  },
];

export const handleChatFallbacks = (input: string): Message[] | null => {
  const text = input.trim().toLowerCase();

  const matched = fallbackEntries.find(entry =>
    entry.keywords.some(keyword => text === keyword.toLowerCase()),
  );
  if (!matched) {return null;}

  return [
    {
      sender: "bot",
      text: isArabicText(input) ? matched.ar : matched.en,
      timestamp: getTime(),
      type: "botMessage",
    },
  ];
};
